<template>
    <div class="common-before-after-summary">
        <div class="common-before-after-summary__values" v-if="data">
            <div class="common-before-after-summary__values-item _accented"
                 v-text="data.sum"
                 v-if="data && data.sum"
            />
            <div class="common-before-after-summary__values-item"
                 v-text="`${item.name ? `${item.name}: ` : ''}${item.value}`"
                 v-for="item in (data.items || [])"
                 v-bind:key="item.name"
            />
        </div>
        <div class="common-before-after-summary__arrow" v-if="data && withAfter">
            <icon name="arrow-right" height="auto" />
        </div>
        <div class="common-before-after-summary__values" v-if="data && withAfter">
            <div class="common-before-after-summary__values-item _accented"
                 v-text="data.sumAfter"
                 v-if="data && data.sumAfter"
            />
            <div class="common-before-after-summary__values-item"
                 v-text="item.valueAfter"
                 v-for="(item, index) in data.items"
                 v-bind:key="item.name + index"
            />
        </div>
    </div>
</template>
<script>
export default {
    name: 'common-before-after-summary',
    props: {
        data: {
            type: Object,
            default: null,
        },
        withAfter: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style scoped lang="less">
@import '~theme';

.common-before-after-summary {
    .typography-medium();

    padding-left: 16px;
    border-left: 2px solid @color-primary;

    display: flex;
    align-items: center;
    justify-content: flex-start;

    white-space: nowrap;

    &__values {
        flex: 0 0 auto;

        &-item {
            .typography-body();

            &._accented {
                .typography-medium();
            }
        }
    }

    &__arrow {
        flex: 0 0 auto;
        padding: 0 2ch;
    }

    @media @media-sm-down {
        flex-direction: column;
        align-items: flex-start;
        &__arrow {
            padding: 2ch 0;
            transform: rotate(90deg);
        }
    }
}
</style>
